export default {
  leoChat: {
    chat_1475da: "企業登入",
    chat_16f606: "整數；單位依設備／約定",
    chat_17dfdc: "我的偏好",
    chat_22f4eb: "用量與計費",
    chat_27e8b6: "標籤（來自記憶偏好）",
    chat_29f404: "調理機配方",
    chat_30_can_4ab820: "近 30 日 CAN 解碼幀",
    chat_30_can_8fe750: "近 30 日 CAN 計量合計",
    chat_30_e47539: "近 30 日已入帳扣款",
    chat_30_token_16fa23: "近 30 日 Token",
    chat_33613d: "對話",
    chat_40d6e4: "以訪客身分繼續（產品與公開諮詢）",
    chat_43631f: "停止聆聽",
    chat_4845c6: "處理中…",
    chat_553891: "填入並對齊設備",
    chat_5cd727: "返回對話",
    chat_62e9d1: "選擇模式",
    chat_6888c5: "儲存",
    chat_6adada: "控制台",
    chat_6d1197: "隱私政策與免責聲明",
    chat_7106a7: "機台商品",
    chat_71c576: "請輸入密碼",
    chat_755be2: "出品建檔",
    chat_7847b8: "送出",
    chat_7e76c4: "尚未建立計費帳戶；儲存後將以所選模式開始計量。",
    chat_805f8b: "使用此內容",
    chat_85406a: "跳過朗讀",
    chat_965a50: "店鋪管理員",
    chat_9b2c38: "輸入訊息",
    chat_9cbbd1: "最近一次辨識",
    chat_a84cf9: "留空＝全域偏好；指定則為該機專屬",
    chat_ab185d: "填入輸入框",
    chat_abd535: "註冊會員",
    chat_api_a76f41: "（訂閱方案請由營運或 API 建立）",
    chat_app_c884f6: "若其他 App 已複製連結或機碼，直接貼上即可。",
    chat_b347b6: "目前計費設定",
    chat_b6d41c: "複製指令",
    chat_cta_title_7535dd: "cta.title",
    chat_curve_soft_7e9ea0: "例如 curve_soft",
    chat_d2de5e: "註冊完成，請以會員身份重新登入後繼續。",
    chat_d5e285: "我已閱讀並同意",
    chat_d5edfc: "複製全文",
    chat_da4d71: "會員登入",
    chat_docs_leo_brain_ident_64cb16: "docs/leo_brain/IDENTITY_PROTOCOL.md",
    chat_docs_leo_brain_leo_p_6f7d10: "docs/leo_brain/LEO_PERSONALIZATION_SCENARIO.md",
    chat_e31e3a: "後台完整登入頁",
    chat_e6a549: "關閉",
    chat_ea544c: "請輸入帳號",
    chat_ef5cb: "重新載入",
    chat_email_leo_fda298: "Email + 密碼；登入後回到 Leo 對話並依步驟完成開通。",
    chat_eur_394b9b: "EUR",
    chat_f98d0d: "儲存設定",
    chat_fe497b: "請以會員帳號登入；店鋪管理員請用「企業後台」分頁。登入後依提示完成家用或商用設定。",
    chat_hintauth_a22705: "hintAuth",
    chat_https_localhost_qr_e4c72c: "需相機權限；建議 HTTPS 或 localhost。對準設備或產品上的 QR／條碼。",
    chat_leo_323396: "Leo 用量與計費",
    chat_leo_99743: "Leo 導覽",
    chat_leo_ac1503: "會員登入並進入 Leo",
    chat_leo_e3ca11: "Leo 開通步驟",
    chat_leo_e7dd0: "Leo",
    chat_leo_e9f6cd: "企業登入並進入 Leo",
    chat_loaderror_108d9d: "載入錯誤",
    chat_name_example_com_cb4900: "name@example.com",
    chat_night_owl_b82e53: "例如 night_owl",
    chat_png_d92bec: "下載 PNG",
    chat_qr_25f92d: "掃描與產品 QR",
    chat_qr_40dfbd: "產生 QR",
    chat_qr_a9ae66: "選取相簿截圖或照片，離線辨識 QR／條碼。",
    chat_session_inputplaceho_bbe0d1: "session.inputPlaceholderZh ||",
    chat_sku_qr_png_c9b88c: "將門市配方關鍵字、網址或 SKU 轉成 QR，可下載 PNG 列印貼標。",
    chat_token_7959d6: "累計 Token（全期間）",
    chat_token_can_dbc_28957f: "查看 Token 與車載 CAN／DBC 用量、錢包／帳本扣款紀錄（請以會員登入，或後台帳號已完成商用綁定）。",
    chat_user_ace2e8: "後台 User 帳號；具備菜單權限者可操作設備與數據中心。",
    chat_voicemictitle_650ed3: "voiceMicTitle",
    chat_voicesiriarialabel_76d873: "voiceSiriAriaLabel",
    chat_wsstatustitle_f6c66f: "wsStatusTitle",
  },
  leoNl: {
      busy: "…",
      close: "Close",
      enable: "要為此語言啟用 Leo NL 嗎？",
      later: "稍後",
      no: "否",
      subProgress: "生成中…",
      subPrompt: "使用 AI 理解 %1$s 語音指令",
      titleProgress: "正在準備 Leo NL 語言理解…",
      titlePrompt: "要為此語言啟用 Leo NL 嗎？",
      titleReady: "Leo NL 語言包已就緒",
      yes: "是",
  },
  route: {
    homePage:'首頁',
    dataDisplay:'數據展示',
    atlas:'地圖',
    journal:'日誌',
    details:'詳情',
    systemSetting:'系統設置',
    loginAccount:'帳號管理',
    merchants:'商家管理',
    devices: "設備管理",
    material: "物料管理",
    deviceConfig: "設備配置",
    channelConfiguration: "通道配置",
    configProfileLibrary: "配置檔庫",
    coffeeMachineChannelSlots: "X600H配方中心",
    configBindDispatch: "綁定與下發",
    leoKnowledgeGroup: 'Leo 知識庫',
    leoKnowledgeModelFields: '型號知識欄位',
    leoKnowledgeEquipmentTypeTypeKey: '設備類型 type_key',
    leoKnowledgeUpload: '知識上傳',
    leoKnowledgeIngestBatch: '入庫批次（自動建立）',
    leoKnowledgePhase1Ssot: 'Phase1 SSOT 管線',
    leoKnowledgeCapabilityMatrix: '能力矩陣',
    leoKnowledgeOnboarding: '智慧型號引導',
    leoKnowledgeTesterConsole: '測試員主控台',
    leoKnowledgePipelineHub: '管線總覽',
    leoKnowledgeFeatureSurface: '功能→API 映射',
    leoKnowledgeProtocolDoc: '協議文檔索引',
    leoKnowledgeRemoteTools: '遙控工具目錄',
    leoKnowledgeLearning: '學習閉環',
    leoKnowledgeExternalIngest: '外部知識入庫',
    leoKnowledgePortalHub: 'Leo 對話與營運',
    leoKnowledgePortalHubDesc: '由此開啟 Leo 對話（主入口）與 Biz 營運功能；Console／Portal 僅內部運維。',
    leoKnowledgePortalHubHint: '主權台為氣泡式智慧對答版面；門戶為精簡入口。若需帶 portalToken／ceoBearer，請在開啟後於網址列補上查詢參數。',
    leoKnowledgeUiSurfaceSample: '後台視覺樣板（舒適灰底）',
    uiSurfaceSampleLead: '示範「頁面淺灰底＋內容白卡」層次，減輕長時間盯全白畫面的疲勞；若滿意可再抽成全域主題變數推廣。',
    uiSurfaceSampleAlert: '此頁僅供視覺與版面參考，表單與表格為示意資料，不會呼叫後端。',
    uiSurfaceSampleKpi_orders: '今日訂單（示意）',
    uiSurfaceSampleKpi_online: '在線設備',
    uiSurfaceSampleKpi_alerts: '待處理告警',
    uiSurfaceSampleKpiSub: '樣板數字',
    uiSurfaceSampleFilterTitle: '篩選區（白卡）',
    uiSurfaceSampleKeyword: '關鍵字',
    uiSurfaceSampleKeywordPh: '名稱或編號',
    uiSurfaceSampleStatus: '狀態',
    uiSurfaceSampleStAll: '全部',
    uiSurfaceSampleStOn: '啟用',
    uiSurfaceSampleStOff: '停用',
    uiSurfaceSampleReset: '重置',
    uiSurfaceSampleSelectPh: '請選擇',
    uiSurfaceSampleTableTitle: '列表示意（白卡＋表格）',
    uiSurfaceSampleColName: '名稱',
    uiSurfaceSampleColRegion: '區域',
    uiSurfaceSampleColStatus: '狀態',
    uiSurfaceSampleColUpdated: '更新時間',
    uiSurfaceSampleCompareTitle: '對照：全白區塊 vs 分層灰底',
    uiSurfaceSampleCompareOld: '舊感：大面積純白',
    uiSurfaceSampleCompareOldDesc: '內容區與背景同色時，邊界較不分明，長時間閱讀容易累。',
    uiSurfaceSampleCompareNew: '建議：灰底上的白卡',
    uiSurfaceSampleCompareNewDesc: '主內容仍在白底上維持對比；頁面級用淺灰承托，視線有落點。',
    leoPortalHubSovereign: '主權台（全屏）',
    leoPortalHubPortal: '門戶',
    leoPortalHubDeviceIntegrationSection: '裝置端整合',
    leoPortalHubDeviceIntegrationLink: '對外說明與工具（新分頁）',
    leoPortalHubRuntimeModuleLink: '裝置雲運行期 AAR（新分頁）',
    leoPortalHubSdkLabSection: 'XRROSS SDK（工程測試）',
    leoPortalHubSdkEngineerLabOpen: '全功能測試台（第一軌＋第二軌，新分頁）',
    leoPortalHubSdkPublicTrack1: '第一軌對外說明',
    leoPortalHubSdkPublicTrack2: '第二軌對外說明',
    leoPortalHubChatSection: '對話入口',
    leoPortalHubPreferences: '我的偏好',
    leoPortalHubLogin: '登入',
    leoPortalHubSectionOps: '營運控制台',
    leoPortalHubSectionOpsDesc: '後台即時對話流、CEO／門戶主權視窗，適合大螢幕驗收與值守。',
    leoPortalHubSectionPortal: '行動門戶',
    leoPortalHubSectionPortalDesc: '精簡入口，方便手機或對外展示。',
    leoPortalHubSectionChat: '智慧對話',
    leoPortalHubSectionChatDesc: 'Leo 智慧對話；下方可調整偏好或登入。',
    leoPortalHubSectionDeviceDesc: '對外說明、運行期模組與整合文檔（皆於新分頁開啟）。',
    leoPortalHubSectionSdkDesc: '工程師用於兩軌串接、回歸與除錯的統一測試台。',
    leoPortalHubCardSovereignDesc: '氣泡式智慧對答、Markdown 與 SOP 步驟卡片。',
    leoPortalHubCardPortalDesc: '精簡 Leo 門戶；必要時於網址加上 portalToken／ceoBearer。',
    leoPortalHubCardLeoDesc: '預設 Leo 對話；一般營運、知識問答與遙控（全球會員同一入口）。',
    leoPortalHubCardPrefDesc: '人設、地區與個人化選項。',
    leoPortalHubCardLoginDesc: '以後台帳號登入後再使用寫入／敏感能力。',
    leoPortalHubCardDeviceIntegrationDesc: '公開說明、Track1 工具與整合檢核表。',
    leoPortalHubCardRuntimeDesc: 'Device Cloud 運行期／AAR 與 Track2 對照入口。',
    leoPortalHubCardSdkLabDesc: '整合測試環境，同時演練第一軌與第二軌行為。',
    leoPortalHubSdkFeaturedTag: '工程',
    leoPortalHubOpenNewTab: '點擊以新分頁開啟',
    leoPortalHubSdkCrossRefHint: '第一軌／第二軌對外說明請使用上方「裝置端整合」兩張卡片。',
    leoFloatDockTitle: 'Leo 對話（懸浮）',
    leoFloatDockMinimize: '最小化',
    leoFloatDockClose: '關閉',
    leoFloatDockResizeHint: '拖曳右下角調整視窗大小',
    leoFloatDockSwitchLabel: '懸浮 Leo 對話',
    leoFloatDockSwitchHint: '開啟後可在各後台頁面使用置前對話框（可拖曳標題列）；進入獨立 Leo／Console／門戶頁時會自動隱藏以免重疊。',
    xrrossIntroNavButton: '認識 XRROSS',
    xrrossIntroHub: '認識 XRROSS',
    leoSmartIntro: '認識 Leo Smart',
    layoutThemeUseDark: '切換為深色主題',
    layoutThemeUseLight: '切換為淺色主題',
    leoProfileWorkbenchLeoMovedPrefix: 'C-Line · Leo：主權台、門戶與 Leo 對話入口已移至側欄「Leo 知識庫」內之',
    leoProfileWorkbenchLeoMovedSuffix: '。',
    equipmentCategory: '設備類別',
    equipmentCategoryEdit: '設備類別－編輯',
    equipmentCategoryDel: '設備類別－刪除',
    equipmentTypePermAdd: '設備類型－查詢／新增（列表）',
    equipmentTypePermEdit: '設備類型－編輯',
    deviceSimulatorConsole: '模擬機－控制台',
    leoDeviceOpsRolePolicy: '命令權限總表',
    leoDeviceOpsSemanticTraining: '語義訓練工作台',
    leoTurnRoutingTrainingHub: 'T0 入口路由訓練台',
    leoKnowledgePortalOpsInventory: 'Portal ops API 盤點台',
    leoKnowledgePortalOpsDailyHub: 'PORTAL_OPS 工作台',
    leoDeviceOpsReviewInbox: 'B 線審核待辦',
    leoDeviceOpsDescriptionAutogen: 'Device_OPS 盤點台',
    leoDeviceOpsBLineDailyHub: 'B 線日常工作台',
    simulatorGroup: '模擬機',
    x600hGateway: 'X600H',
    xt90c2Simulator: 'XT90C2',
    blenderSimulator: 'Blender',
    maestroSimulator: 'Maestro模擬機',
    storefrontSimulator: '點單機Kiosk',
    productCenter: "出品管理",
    productCenterFolderOther: '其他產品',
    dataCenter: "數據中心",
    maintenance: "運維管理",
    filesCenter:'文件管理',
    menuSetting:'菜單設置',
    organization:'用戶組織',
    loginAccount:'帳號列表',
    authorization:'角色管理',
    merchants:'商家列表',
    deviceList:'設備列表',
    deviceAutoServiceGroup: '售後維修保養',
    supportTicketGroup: '售後支持',
    supportTicketCreate: '提交工單',
    supportTicketMine: '我的工單',
    supportTicketWorkbench: '售後工作台',
    supportPlaybook: '標準問答庫',
    deviceServiceWorkbench: '售后工單工作台',
    deviceServiceMyAssignments: '我的維修任務',
    deviceServiceAssignees: '維修負責人',
    deviceServiceMaintenance: '保養計劃',
    deviceServiceFaultPolicy: '故障開單策略',
    deviceServiceEnterprisePolicy: '企業自動售后策略',
    deviceServiceMobile: '維修任務（手機）',
    deviceServiceBills: '維修帳單',
    deviceServiceAnalytics: '故障分析',
    storeMaterialStock: '庫存總覽',
    storeMaterialOrders: '採購訂單',
    storeMaterialConsumable: '耗材 BOM',
    storeMaterialMq: 'MQ 配置',
    storeMaterialInvoice: '發票',
    storeMaterialBarcodeAlias: '掃碼映射',
    storeMaterialCount: '倉庫盤點',
    storeMaterialBomWizard: 'BOM配置嚮導',
    storeMaterialAnalytics: '物料使用報告',
    channelCategory:'通道類型',
    productCategory:'出品類型',
    optionCategory:'規格類型',
    optionList:'規格列表',
    storeAccount:'店舖帳號',
    stores:'店舖管理',
    modelName:'設備名稱/型號',
    category:'物料類型',
    configDistribute:'通道下發',
    devicesChannels:'設備通道',
    productsList5:'出品列表5',
    produceFivePos:'產品5門店客制',
    posCenter:'POS中心',
    menuDistribute:'菜單下發',
    storeMenu:'店鋪菜單',
    merchantsData:'商家統計數據',
    devicsData:'設備統計數據',
    productionData:'設備出品數據',
    maintanenceData:'設備售後數據',
    devicesWorkingData:'設備使用數據',
    afterSalesReminder:'售後提示',
    maintenanceTips:'保養提示',
    fileUpgrade:'文件升級',
    dataDowloan:'數據下載',
    materialList:'物料列表',
    accessoriesCategory:'小吃類型',
    accessoriesList:'小吃列表',
    businessCenter: '業務中心',
    afterSalesServiceGroup: '售後服務',
    storeMaterialGroup: '庫存管理',
    appsBanner:'App橫幅展示',
    advertisement:'廣告清單',
    advertBind:'廣告綁定',
    advertDistribute:'廣告下發',
    membersCenter:'會員列表',
    orderCenter:'訂單列表',
    packBag:'打包袋子',
    appsCenter:'app管理',
    productsList2:'出品列表2',
    XTSeriesData:'配料機數據',
    productionData:'出品數據',
    materialDate:'物料數據',
    qualityData:'單杯數據',
    alertsLog:'故障日誌',
    cleaningLog:'清洗記錄',
    coffeeData:'咖啡機數據',
    coffeeMachineProductionData:'X600H 出品數據',
    coffeeMachineSingleCupData:'X600H 單杯數據',
    coffeeSumData:'品質數據',
    taxCenter:'稅務中心',
    taxManagement:'稅務管理',
    taxAllocation:'稅務配置',
    dataOfTeaExtractorMachine:'萃茶機數據',
    teaMachineMaterial: '物料損耗',
    teaEarlyBrewWork: '多機互聯工作',
    ecosystemMallGroup: '生態商城',
    ecosystemMallTopology: '商店拓撲',
    ecosystemMallCatalog: '商品與章節',
    ecosystemMallWebsitePages: '官網產品頁',
    ecosystemMallSynergyEdges: '協同邊開閘',
    ecosystemMallIntents: '意向／諮詢單',
    ecosystemMallVendors: '供應商與人員',
    ecosystemMallMediaBilling: '媒資AI／計費',
    ecosystemMallProductSpecs: '產品規格／缺料',
    ecosystemMallLines: '產線組合',
    ecosystemMallSearch: '搜尋推薦',
    ecosystemMallEquipmentDemands: '設備需求單',
    storeAssortmentOptimization: '店鋪選品優化',
    storeAssortmentGroup: '店鋪選品',
    storeAssortmentDesk: '選品優化工作台',
    storeAssortmentView: '查看',
    storeAssortmentGate: '開閘',
    teaSingleCupParams: '單杯參數',
    dataOfBlendExtractorMachine:'冰沙機數據',
    dataOfMilkExtractorMachine:'奶沫機數據',
    beverageOutputData:'出品數據',
    singleCupData:'單杯數據',
    faultLog:'故障日誌',
    deliveryPlatform:'外賣平台',
    uber:'Uber',
    otherProducts:'其他產品',
    listOfTeaExtractsProducts:'萃茶機產品',
    machineDebug:'設備調試',
    deviceRdGroup:'設備研發',
    presetCommand:'預設命令',
    commandConfiguration:'命令配置',
    memberHqGroup: '會員 HQ',
    memberHqDashboard: 'HQ 總覽',
    memberHqFinance: '財務匯總',
    financeAccountingReports: '會計報表',
    financeAccountingGroup: '財務會計',
    storeCostOptimizeGroup: '成本效率',
    storeCostOptimizeDesk: '成本優化工作台',
    storeCostOptimizeView: '查看',
    storeCostOptimizeGate: '放閘',
    storeOpsCeoDeskGroup: '運營總決策台',
    storeOpsCeoDecisionDesk: 'CEO 運營決策台',
    storeOpsCeoDecisionDeskView: '查看',
    storeOpsCeoDecisionDeskDecide: '決策',
    aiEngineeringControlGroup: 'AI 工程總控',
    aiEngineeringControlDesk: '工程總控台',
    aiEngineeringControlDeskView: '查看',
    storePnLGroup: '店務 P&L',
    storePnLDesk: 'P&L／現金工作台',
    storePnLDeskView: '查看',
    storePnLDeskGate: '日結／分錄',
    hkTaxFilingDesk: '香港報稅工作台',
    hkTaxFilingDeskView: '查看',
    hkTaxFilingDeskGate: '產包／人閘',
    xhmHardwarePartnerGroup: 'XHM 硬件伙伴',
    xhmHardwarePartnerDesk: '伙伴／月結工作台',
    xhmHardwarePartnerDeskView: '查看',
    xhmHardwarePartnerDeskGate: '月結／掛單',
    xhmFamilySlotGroup: 'XHM 三軌槽位',
    xhmFamilySlotDesk: '槽位工作台',
    xhmFamilySlotDeskView: '查看',
    xhmFamilySlotDeskGate: '保存槽位',
    hkMarketChannelGroup: '香港上市通道',
    hkMarketChannelDesk: 'HK 收款／WhatsApp 工作台',
    hkMarketChannelDeskView: '查看',
    hkMarketChannelDeskGate: '模擬／配置',
    hkMarketSignup: '港店簽約上手',
    hkMarketSignupGate: '簽約提交',
    cnMarketChannelGroup: '大陸上市通道',
    cnMarketChannelDesk: '陸店收款／社交工作台',
    cnMarketChannelDeskView: '查看',
    cnMarketChannelDeskGate: '模擬／配置',
    cnMarketSignup: '陸店簽約上手',
    cnMarketSignupGate: '簽約提交',
    storeAutonomousMarketingGroup: '店鋪自主營銷',
    storeAutonomousMarketingDesk: '自主營銷工作台',
    storeAutonomousMarketingView: '查看',
    storeAutonomousMarketingGate: '放閘',
    workforceGroup: '排班出勤',
    workforceWeekSchedule: '週排班',
    workforceClock: '打卡出勤',
    workforceSummary: '出勤匯總',
    workforceSmartRoster: '智能排班',
    workforceMySchedule: '我的班表',
    workforcePayroll: '薪資月結',
    memberHqOps: '營運入口',
    distributorReportGroup: '渠道報表',
    distributorDashboard: '渠道總覽',
    distributorMembers: '我的會員',
    distributorProfit: '分潤明細',
    merchantTokenBillingPlatform: '帳單平台',
    merchantDataBillingPlatform: '車載數據帳單',
    linuxAutoOps: '車載運營',
    linuxAutoEquipment: '車載設備',
    linuxAutoRemoteOps: '遠程運維',
    linuxAutoProfileConfig: 'Profile 配置',
    linuxAutoDataBilling: 'CAN 數據帳單',
    linuxAutoModelRegistry: '型號註冊',
    linuxAutoPartnerDelivery: '夥伴交付',
    linuxAutoFleetMonitor: '車隊監控',
    linuxAutoDbcEntitlement: 'DBC 授權',
    linuxAutoCabinFeatures: '座艙功能',
    linuxAutoCanAutoMatch: 'CAN 自動匹配',
    operationAndMaintenanceServices:'運維服務',
    productionList:'出品清單',
    smallMaterial:'小料列表',
    takeoutProducts:'外送產品',
    pointRule:'積分規則',
    couponManagement:" 優惠券管理",
    couponList:" 優惠券列表",
    additionalProducts:'額外產品',
    type:'產品類型',
    taxAllocation:'稅務配置',
    produce:'產品列表',
    produceList4:'出品列表4',
    smoothieMakerProduct:'冰沙機出品',
    machineMenu:'設備菜單',
    systemLog:"系統日誌",
    region:'區域'
    },
    acoount: {
    name: '名稱',
    enterpriseName: '企業名稱',
    account: '帳號',
    password: '密碼',
    confirmPassword: '確認密碼',
    roleTitle:'角色職稱',
    roleName:'角色名稱',
    searchKeyword:'帳號/手機/郵箱/角色',
    phone:'手機號碼',
    email:'郵箱',
    idNumber:'證件號',
    workAddress:'工作地址',
    status:'狀態',
    onDuty:'在崗',
    leaveDuty:'離崗',
    takeVacationrm:'休假',
    disable:'停用',
    profilePicture:'頭像',
    confirmPasswordCannotBeEmpty:'確認密碼不能為空',
    inconsistentPasswordInput:'密碼輸入不一致',
    emailFormatError:'郵箱格式錯誤',
    phoneNumberFormatError:'手機號碼格式錯誤',
    notes:'備註',
    empower:'授權',
    contactInformation:'聯絡方式',
    userOrganizationType:'用戶組織類型',
    userOrganizationName:'用戶組織名稱',
    describe:'描述',
    available:'可用',
    deactivate:'停用',
   
    },
    merchant: {
    account: '登陸帳號',
    password: '密碼',
    store: '店家',
    status:'狀態',
    available:'正常',
    deactivate:'停用',
    merchantName:'商家名稱',
    searchKeyword:'商家名稱/負責人/電話/地址',
    cooperationType:'商戶類型',
    selectCooperationTypeFirst:'請先選擇商戶類型',
    noUserOrganizationForType:'該類型下暫無用戶組織，請先在「用戶組織」中配置',
    enterpriseSegment:'經營場景',
    segmentDistributor:'渠道批發',
    segmentShop:'門店商用',
    segmentHome:'家用 Leo',
    businessLicense:'營業執照',
    frontIDCard:'身分證正面',
    backIDCard:'身分證反面',
    head:'負責人',
    Telephone:'聯絡電話',
    userOrganization:'使用者組織',
    businessAddress:'註冊地址',
    trade:'營業',
    closeBusiness:'歇業',
    superior:'上級',
    supervisorSubordinateRelation:'上下級關係',
    clickView:'點看',
    business:'商家',
    country:'國家',
    address:'地址',
    shopNames:'店名',
    storeType:'門店類型',
    selfService:'自助',
    askFor:'自取',
    SelfPickupTakeoutShop:'自取+外送店',
    selfServicePickUpTakeout:'自助+自取+外賣',
    businessHours:'營業時間',
    closingTime:'打烊時間',
    operatingCycle:'營業週期',
    Monday:'週一',
    Tuesday:'週二',
    Wednesday:'週三',
    Thursday:'週四',
    Friday:'週五',
    Saturday:'週六',
    Sunday:'週日',
    picture:'圖片',
    vatNumber:'VAT增值稅號',
    kvtCompanyRegistrationNumber:'KVK公司註冊號碼',
    invoiceUnifiedNumbering:'發票統編',
    invoiceAccountNumber:'發票帳號',  
    POSAPIKey:'POS API Key',
    POSAccount:'POS Account',
    APPAPIKey:'APP API Key',
    APPAccount:'APP Account',
    APPClientKey:'APP Client Key',
    
   
    },
    device:{
      deviceType:'設備類型',
      totalDevice:'設備總數',
      passConfigName:"名稱",
      offLineDevice:'離線設備',
      materialShortageDevice:'缺料設備',
      alertingDevice:'警報設備',
      lockDevice:'鎖機設備',
      maintenanceDevice:'需要保養設備',
      businessInformation:'設備業務資料',
      deviceId:'設備ID',
      deviceModel:'型號',
      modelCodeKey:'型號代碼',
      modelCodePlaceholder:'例：PT5 或 XRROSS_PT5，需全站唯一',
      modelCodeRequired:'請填寫型號代碼（對應 Leo model_key）',
      dealer:"零售商",
      deviceImie:'設備編碼',
      appVersion:'App版本',
      appKeyword:'軟體名稱',
      appVersionOp:'版本比較',
      appVersionOpEq:'等於',
      appVersionOpContains:'包含',
      appVersionOpLt:'低於',
      appVersionOpGt:'高於',
      appVersionOpLte:'不高於',
      appVersionOpGte:'不低於',
      appVersionFilter:'機上版本',
      appVersionReportStatus:'版本上報',
      appReportHas:'有上報',
      appReportNone:'從未上報',
      appReportStale:'上報過期(7天)',
      appPublishRel:'對比發版',
      appPublishBehind:'落後發版',
      appPublishEqual:'等於發版',
      appPublishAhead:'高於發版',
      equipmentSerialNumber:'設備序列號',
      posNumber:'刷卡機編碼',
      store:'商家',
      location:'設備位置',
      none:'暫無',
      log:"日誌",
      fault:"故障",
      normal:"正常",
      offline:"離線",
      linkOffline:"模組離線",
      onLine:"在線",
      isFault:"是否有故障",
      type:"類型",
      fullyAutomatic:"全自動",
      semiAutomatic:"半自動",
      availableMerchants:"可使用商家",
      faultStatistics:"故障統計",
      basicMaintenance:"基礎保養",
      deepMaintenance:"深度保養",
      onLineDevice:'在線設備',
      equipmentOnlineStatus:"設備狀態:",
      moduleLinkStatus:"模組連線:",
      hostProduceStatus:"主機可製作:",
      hostReadyCanProduce:"可製作",
      hostReadyNeedWake:"需喚醒",
      hostReadyUnknown:"未知",
      linkOnlineHostSleep:"在線·主機休眠",
      macFastRebindEnabled:"MAC快速重綁",
      macFastRebindPending:"重綁未就緒",
      brandName: "品牌:",
      telephone: "電話:",
      equipmentModelName: "設備名稱/型號:",
      dateOfManufacture: "生產日期:",
      usageDate: "使用日期:",
      menu:"選單",
      productName :"產品名稱",
      channelConfiguration :"通道配置",
      channelNumber :"通道號",
      material :"物料",
      shelfLife :"有效期",
      alarmListForTheDay: "警報列表(當天)",
      content :"內容",
      time :"時間",
      key: "按鍵",
      frequency :"次數",
      remoteOperation :"遠端操作",
      success :"成功",
      menuStatus: "選單狀態",
      updated: "已更新",
      notUpdated: "未更新",
      lock: "鎖定",
      unlock: "解鎖",
      startup: "啟動",
      shutdown: "關機",
      restart: "重啟",
      param:"參數",
      factoryParam:"工廠參數",
      moduleParam:"模塊參數",
      paramBaselineOpen:'設置參數',
      paramBaselineTitle:'設置參數（Leo 型號基準）',
      paramBaselineHint:'參數鍵請與設備配置 JSON path 一致（例：config.stirTime）；儲存後供 Leo 與機器實際配置比對。',
      paramBaselineAddRow:'新增參數列',
      paramBaselineSave:'儲存',
      paramBaselineRefresh:'重新載入',
      paramKey:'參數鍵',
      paramKeyPh:'例：config.stirTime',
      paramDisplayName:'顯示名稱',
      standardValue:'標準值',
      lowerLimit:'下限',
      upperLimit:'上限',
      unit:'單位',
      paramRemark:'備註',
      paramBaselineNoProfile:'此型號尚無可讀取之 L1 配置檔（或尚無 PUBLISHED 版）。請先於「配置檔管理」建立／發佈綁定該型號之 Profile。',
      paramBaselineProfileSource:'參數預設來源：{name} · published 版號 {version}',
      paramBaselineApplyPublished:'自最新 published 套用',
      paramBaselineApplyConfirm:'將依最新 published 之 JSON 合併至表格（同鍵將覆寫標準值與上下限，並新增未存在之鍵）。確定？',
      paramBaselineApplyDone:'已套用 published 建議值（請確認後儲存）',
      paramBaselineTypeUnionTitle:'同設備類型 · 各型號 published 路徑聯集（參考）',
      paramBaselineTypeUnionMissing:'無 Profile 之型號 ID'
      },
      produce: {
      name: '名稱',
      price: '價格',
      uberPrice: 'Uber單價',
      matterType: '物料類型',
      normType: '規格類型',
      matter: '物料',
      min: '最小值',
      max:'最大值',
      shelfLife:'保鮮期',
      unit:'單位',
      hour:'小時',
      step1:'產品資料',
      step2:'產品物料',
      step3:'產品配方',
      step4:'配方組合',
      step5:'產品小料',
      produceName:'出品名稱',
      produceCode:'出品編碼',
      produceType:'出品類型',
      showSnacks:'顯示小吃',
      yes:'是',
      no:'否',
      describe:'描述',
      order:'順序',
      value:'值',
      unit:'單位',
      norm:'規格',
      select:'選擇',
      step:'步驟',
      matterSequence:'物料順序',
      action:'操作',
      freeSnacks:'免費配料',
      feeBasedMaterials:'收費配料',
      nextStep:'下一步',
      back:'上一步',
      save:'儲存',
      saveUpdate:'儲存更新',
      productList:'出品選單',
      selectProduct:'選擇出品',
      menuSort:'排序',
      produceImport:'出品導入',
      bind:'綁定',
      bindMachien:'綁定設備',
      smallMatterType:'小料類型',
      listing:'上架',
      isSales:'可下單',
      productListName:"輸入出品菜單名稱",
      Text1:'輸入出品名稱',
      Text2:'商家',
      Text3:'物料',
      Text4:'配料',
      Text5:'飲品',
      Text6:'小吃',
      Text7:'新增配方',
      Text8:'更新',
      Text9:'該產品編碼已存在',
      Text10:'請完善產品信息',
      Text11:'茶品',
      Text12:'第一段',
      Text13:'第二段',
      Text14:'第三段',
      Text15:'出',
      Text16:'不出',
      Text17:'範圍:',
      Text18:'茶葉量:',
      Text20:'冰塊量:',
      Text21:'攪拌時間不能大於同段萃茶/萃取時間（上限 {max}）',
      Text22:'萃茶/萃取時間不能小於目前攪拌時間（{min}）',
      Text23:'配方「{name}」攪拌時間超過萃茶/萃取時間（上限 {max}），請調整後再保存',
      codeRule:'編輯規則',
      prefix:'字首',
      suffix:'後綴',
      review:'預覽',
      codeRuleDescribe:'這個格式就是收銀系統列印編碼的格式',
     
      },
      business: {
      name: '名稱',
      type: '類型',
      homepage: '首頁',
      advertisingList: '廣告清單',
      pictureOrVideo: '圖片/影片',
      addProductAdvertisements:'新增產品廣告',
      AddImagesOrvideos:'新增圖片/視頻',
      userName: '使用者名稱',
      email: '郵箱',
      sex: '性別',
      birthday: '生日',
      phone: '手機號',
      walletBalance: '錢包餘額',
      integral: '積分',
      orderNo: '訂單編號',
      pickupCode: '取餐碼',
      store: '店家',
      amount: '訂單金額',
      payAmount: '實付金額',
      receiptsPrice: '實收金額',
      discount: '優惠',
      orderStatus: '訂單狀態',
      toBePaid: '待支付',
      paid: '已支付',
      processing: '處理中',
      completed: '已完成',
      orderCancellation: '訂單取消',
      orderRejection: '訂單拒絕',
      paymentMethod: '支付方式',
      wallet: '錢包',
      cash: '現金',
      pos: '刷卡機',
      thirdParty: '第三方',
      otherPay: '其他',
      produce: '出品',
      unitPrice: '單價',
      number: '數量',
      parameter: '參數',
      totalTaxAmount:'總稅額',
      taxName:'稅名',
      taxAmount:'稅額',
      taxRate:'稅率',
      orderType: '訂單類型',
      pack: '打包',
      dineIn: '堂食',
     
      },
      file: {
        name: '名稱',
        version: '版本',
        keyword: '標識',
        file:'文件',
        upload:'上傳',
        remark: '備註',
        publishStatus: '發布狀態',
        published: '對外最新',
        archived: '已歸檔',
        backupStatus: '伺服器備份',
        backedUp: '已備份',
        notBackedUp: '未備份',
        otaStatus: 'OTA狀態',
        otaLiveBacked: '對外最新·已備份',
        otaLiveNoBackup: '對外最新·未備份',
        otaArchivedBacked: '已歸檔·已備份',
        otaArchivedNoBackup: '已歸檔·未備份',
        otaLinkBroken: '鏈接失效',
        otaStatusTipTitle: '狀態說明：',
        otaStatusTipLiveBacked: '綠＝正在對外發且伺服器有備份，正常。',
        otaStatusTipLiveNoBackup: '橙＝正在對外發但未備份，請補備份或重傳。',
        otaStatusTipArchivedBacked: '灰＝已不對外，但可回滾。',
        otaStatusTipArchivedNoBackup: '紅＝已歸檔且無備份，基本不可回滾，建議重傳。',
        otaStatusTipLinkBroken: '紅「鏈接失效」＝下載地址空或雲端 404/不通，請重新上傳 APK。',
        recheckLinks: '重新檢查鏈接',
        history: '歷史',
        historyTitle: '版本歷史',
        backupNow: '補備份',
        batchBackup: '批量補備份',
        batchArchive: '批量歸檔',
        batchBackupConfirm: '確認對勾選項執行補備份？',
        batchBackupDone: '批量補備份結束',
        selectFirst: '請先勾選要操作的 APP',
        copyLink: '鏈接',
        linkCopied: '下載鏈接已複製',
        linkCopyFailed: '複製失敗，請手動複製',
        noDownloadLink: '此 APP 尚無下載鏈接',
        backupRemoteGone: '雲端 APK 已不存在（404）。請重新上傳 APK 後再備份。',
        archive: '歸檔',
        archiveConfirm: '歸檔後舊設備不再取此版（檔案保留可回滾），確認',
        rollback: '回滾',
        rollbackConfirm: '確認回滾為此版本？當前對外最新將歸檔保留。',
        otaBackupHint: '儲存後系統會把包拉到伺服器製品倉備份；舊設備仍用原下載連結。',
        otaReuploadHint: '若補備份報 404：雲端檔已刪，請在此重新上傳 APK 後再按確定。',
        otaGray: '灰度',
        otaGrayOff: '全量',
        otaGrayOn: '灰度({n}台)',
        otaGraySet: '設置灰度',
        otaGrayHint: '開=僅白名單機碼可升此版；關或名單空=全量。',
        otaGrayMachines: '灰度機碼',
        otaGrayMachinesPlaceholder: '一行一個機碼，也可用逗號分隔',
        otaForceUpgrade: '強制升級',
        otaForceUpgradeHint: '開=機端不可取消更新；可與灰度並用。',
        otaPushForce: '立即推送',
        otaPushForceConfirm: '向灰度白名單機立即推送強制升級檢查？離線機會記為 offline。',
        otaPushForceResult: '推送完成：共 {total}，送達 {delivered}，離線 {offline}',

        pendingIntentGate: 'PendingIntent閘',
        pendingIntentGatePass: '已過閘',
        pendingIntentGateSkip: '已跳過',
        pendingIntentGateNa: '不適用',
        pendingIntentGateFail: '未過閘',
        pendingIntentGateUnknown: '未標記',
        pendingIntentGateTipPass: '發版時已通過 Android 12 PendingIntent 硬閘（可安全作為 OTA 源）。',
        pendingIntentGateTipSkip: '發版時人工跳過硬閘，存在風險。',
        pendingIntentGateTipNa: 'targetSdk 較低或無 UpdateDialog，硬閘不適用。',
        pendingIntentGateTipFail: '已掃描：targetSdk≥31 且 UpdateDialog 缺少 PendingIntent 修法，從此版 App 內 OTA 會崩。',
        pendingIntentGateTipUnknown: '歷史版本無閘標記；新發版或回填掃描才會寫入。'
        },
        coupon: {
        Text1: '名稱',
        Text2: '優惠金額',
        Text3: '消耗積分',
        Text4:'狀態',
        Text5:'詳情',
        Text6:'可用',
        Text7:'不可用',
        Text8:'有效天數'
       
        },
        pass: {
        name: '名稱',
        pass: '通道',
        passNumber: '頻道號碼',
        preDischargeTime: '預出料時間',
        addPass:'新增頻道',
        bindPass:'通道綁定',
        passConfigName:'通道設定名稱'
       
        },
        operation:{
        business_data:"業務數據看板",
        orderAmount:"訂單金額",
        orderQuantity:"訂單數量",
        actualAmountReceived:"實收金額",
        top_10_beverage_rankings:"飲品榜Top10",
        sales_revenue:"銷售額",
        order_quantity:"訂單數量",
        payment_method:"付款方式",
        real_time_orders_on_the_hour:"整點即時訂單",
        },
        dataCenter:{
          Text1:"內容",
          Text2:"資料",
          Text3:"銷售量/杯",
          Text4:"銷售額/元",
          Text5:"消耗物料/g",
          Text6:"月",
          Text7:"日",
          Text8:"時",
          Text9:"圖表",
          Text10:"單杯消耗物料",
          Text11:"排名",
          Text12:"出品消耗物料",
          Text13:"設備消耗物料",
          Text14:"百分比",
          Text15:"排名",
          Text16:"銷售量",
          Text17:"銷售額",
          Text18:"時間/S",
          Text19:"出品銷售量",
          Text20:"出品銷售額",
          Text21:"設備銷售量",
          Text22:"設備銷售額",
          Text23:"總杯數",
          Text24:"總配方量/克",
          Text25:"實際總配方量/克",
          Text26:"壞杯量/杯",
          Text27:"壞杯率/%",
          Text28:"誤差率/%",
          Text29:"出品名稱",
          Text30:"製作方式",
          Text31:"掃碼",
          Text32:"產品",
          Text33:"手動",
          Text34:"訂單號碼",
          Text35:"門市",
          Text36:"單價",
          Text37:"配方總量",
          Text38:"實際出杯量",
          Text39:"出杯時間",
          Text40:"誤差(%)",
          Text41:"壞杯",
          Text42:"正常",
          Text43:"製作完成",
          Text44:"製作失敗",
          Text45:"完成時間",
          Text46:"模式",
          Text47:"頻道",
          Text48:"狀態",
          Text49:"未完成",
          Text50:"完成",
          Text51:"出品名稱",
          Text52:"杯數",
          Text53:"總價",
          Text54:"訂單統計",
          Text55:"訂單列表",
          Text56:"訂單金額",
          Text57:"訂單數量",
          Text58:"實收金額",
          Text59:"產品金額",
          Text60:"茶葉量",
          Text61:"出水量",
          Text62:"銷售量/桶",
          Text63:"桶",
          Text64:"偏酸/萃取過短",
          Text65:" 均衡/萃取中等",
          Text66:"偏苦/萃取過度",
          Text67:"味苦/濃度低",
          Text68:"適中",
          Text69:"強/濃度高",
          Text70:"萃取时间",
          Text71:"水粉比",
          strongBalance:"強平衡",
          weakBalance:"弱平衡",
          mediumAcid:"中酸",
          strongAcid:"強酸",
          goldenCup:"金杯",
          weakAcid:"弱酸",
          bitter:"苦",
          strongBitter:"強苦",
          weakBitter:"弱苦",
          extractionTime:"萃取時間",
          Text72:"動態校準",
          },
          taxation:{
          Text1:"稅名",
          Text2:"稅率",
          Text3:"基數",
          Text4:"備註",
          Text5:"國家",
          Text6:"型別",
          Text7:"內用",
          Text8:"打包",
          Text9:"產品类型",
          Text10:"稅種",
          Text11:"平台外賣",
          },
          uber:{
          Text1:"uber店舖",
          Text2:"平台店舖",
          Text3:"菜單狀態",
          Text4:"店舖狀態",
          Text5:"已綁定",
          Text6:"未綁定",
          Text7:"同步"
         
          },
          login: {
          title: '系統登入',
          logIn: '登入',
          username: '帳號',
          password: '密碼',
          readAndAgree:'已閱讀並同意',
          pleaseCheckThePrivacyAgreement:'請勾選隱私政策與免責聲明',
          termTip:'《隱私政策與免責聲明》',
          Text1:'請輸入帳號',
          Text2:'請輸入帳號',
          leoSmartComingSoon: 'Leo Smart 專業站即將上線'


          },
          navbar: {
          logOut: '退出登入',
          dashboard: '首頁',
          github: '項目地址',
          screenfull: '全螢幕',
          theme: '換背景顏色',
          size: '布局大小'
          },
          tagsView: {
          refresh: '刷新',
          close: '關閉',
          closeOthers: '關閉其它',
          closeAll: '關閉所有'
          },
          common:{
          tower:'台',
          yuan:'元',
          cup:'杯',
          place:'位',
          individual:'個',
          language:'語言',
          success:'成功',
          fail:'失敗',
          createTime:'創建時間',
          all:'全部',
          common:'全部',
          sureDel:'確定刪除',
          tip:'提示',
          status:'狀態',
          bing:'綁定',
          pleaseSelectDevice:'請選擇設備',
          pleaseSelectMenu:'請選擇菜單',
          pleaseSelectModel:'請選擇型號',
          pleaseSelect:'請選擇',
          code:'編碼',
          entering_the_platform:'進入平台',
          date:"日期",
          address_fail:"地址不正確",
          back:'返回',
          pleaseEnter:'請輸入',
          uploadImageBtn:'點擊上傳圖片',
          uploadImageBtnTip:'僅支援上傳JPG 格式和PNG格式（限制10M以內）',
          uploadVideoBtn:'點擊上傳影片',
          uploadVideoBtnTip:'僅支援上傳mp4或MP4檔案（限制50M以內）',
          videoPlayTip:' 您的瀏覽器不支援影片播放',
          menuVersion:"選單版本"
          },
          table:{
          search: '查詢',
          detail:'詳情',
          actions: '操作',
          edit: '編輯',
          publish: '發布',
          delete: '刪除',
          cancel: '取 消',
          confirm: '確 定',
          add:'新增',
          copy:'複製',
          produceCodeRule:'編碼規則',
          batchDeletion:'大量刪除',
          batchImport:'批次導入',
          batchCopy:'批量複製',
          export:'數據導出',
          exportAll:'匯出全部',
          import:'導入',
          templateDownload:'模板下載',
          dragAndDropUpload:'將檔案拖曳到這裡，或點擊以上傳',
          picture:'圖',
          resetPwd:'重設密碼'
          },
          coffeeData:{
          Text1:"浸泡流量",
          Text2:"浸泡時間",
          Text3:"萃取流量",
          Text4:"萃取壓力",
          Text5:"萃取溫度",
          Text6:"訂單類型",
          Text7:"狀態",
          Text8:"出杯時間",
          Text9:"粉量",
          Text10:"設備編碼",
          Text11:"出品名稱",
          Text12:"咖啡液",
          Text13:"壓粉力道",
          Text14:"粉餅厚度",
          Text15:"萃取流速",
          Text16:"萃取腔體位置",  
          Text17:"研磨度1",
          Text18:"研磨度2",
          }
}


// WEBPACK FOOTER //
// ./src/lang/zh-tw.js